import { connect } from 'react-redux';
import { compose } from 'redux';
import { LN } from '../../../constants/measure';
import LNView from '../../LNView';
import withAvatar from '../../../common/avatar/withAvatar';
import AvatarView from '../../../common/avatar/avatarView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import selectors from '../../../rootSelectors';
import { fetchLNContent } from '../../LNActions';
import { narrateScreen, onResponseSelect } from './LNQuestionsActions';
import { QUESTIONS } from '../../../constants/assessmentItemType';
import { selectPossibleResponse } from '../../../common/questions/questionsActions';
import { getQuestionIndex } from '../../../common/utils/urlParsers';
import avatarAudio from '../../LNConstants';

const mapStateToProps = (state, ownProps) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        pageLayout: `${LN.ASSESSMENT}`,
        isDataFetched: selectors.getIsLNDataFetched(state),
        stimulus: selectors.getLNStimulus(state, QUESTIONS, questionIndex - 1),
        selectedResponses: selectors.getMultiChoiceResponses(state),
        totalQuestions: selectors.getLNTotalQuestions(state, QUESTIONS, questionIndex - 1),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchLNContent());
        },
        narrateScreen: ({ audio }) => dispatch(narrateScreen(audio, avatarAudio.practiceInstructionStart)),
        selectResponse: (responseLetter) => {
            dispatch(selectPossibleResponse(responseLetter));
            // Timeout for better UI/UX
            setTimeout(() => {
                dispatch(onResponseSelect(responseLetter, questionIndex));
            }, 200);
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
});

const LNQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(LNView);

export default LNQuestionsContainer;
